import axios from "axios";
import {API_URL} from "../../../utils/apiURLs";

// LIST
export function getQNAByFilter(params) {
  return axios.get(`${API_URL.QNA_LIST}`, {params});
}

// READ
export function getQNAById(qnaId) {
  return axios.get(`${API_URL.QNA_LIST}/${qnaId}`);
}
